import React from 'react';
import { func } from 'prop-types';
import { translate } from 'react-i18next';

import { CenteredLayout } from '@snapask/common-components';
import BasicCard from '@dragonfruit/components/authCard/BasicCard';
import Link from '@dragonfruit/components/Link';
import LoginForm from '@dragonfruit/components/LoginForm';

import styles from './LoginLayout.scss';

function LoginLayout({ t }) {
  return (
    <CenteredLayout>
      <BasicCard>
        <h1 className={styles.title}>{t('login.title')}</h1>
        <LoginForm />
      </BasicCard>

      <div className={styles.signup}>
        {t('login.do-not-have-an-account')}
        <Link to={'/signup'}> {t('login.signup')} </Link>
      </div>
    </CenteredLayout>
  );
}

LoginLayout.propTypes = {
  t: func.isRequired,
};

export default translate(['login', 'error', 'seo'])(LoginLayout);



// WEBPACK FOOTER //
// ./app/containers/Login/components/LoginLayout/LoginLayout.jsx